/**
 * Global configuration
 */

export const DEBUG = process.env.NODE_ENV === "development";
export const BENCHMARK = DEBUG;
export const GOOGLE_CLIENT_ID = "882464859823-gq99p3ig1kur4bj20eqovcoa0bl5tnl3.apps.googleusercontent.com";
